import {
  IonCol,
  IonContent,
  IonIcon,
  IonText,
  IonPage,
  IonRow,
  IonButton,
  IonLabel,
  IonInput,
  IonCheckbox,
  IonSelect,
  IonSelectOption,
  IonItemDivider,
  IonGrid,
  IonTextarea,
  useIonAlert,
  IonItem,
  IonImg,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { checkmarkCircleSharp, close, informationCircleSharp } from "ionicons/icons";
import { Modal } from "react-bootstrap";
import "./ProjectDonationUser.css"
import { heart, arrowBack } from "ionicons/icons";
import UserHead from "./UserHead";
import Foot from "./Foot";
import Authservice from "../Services/user.service";
import useRazorpay from "react-razorpay";
import { useLocation, Link, useHistory } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import UserService from "../Services/auth.service";
import { useForm } from "react-hook-form";
import validator from 'validator'
import { error } from "console";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { joinhand, heart1, tick, closeicon, infoicon } from "../theme/imagePath";
import HeadFoot from "./Head";


const ProjectDonationUser: React.FC = (props) => {
  const [userdata, setUserdata]: any = useState(sessionStorage.getItem("UserData"));
  const [token, settoken]: any = useState(sessionStorage.getItem("token"));
  const [userId, setUserId]: any = useState(sessionStorage.getItem("UserId"));
  const location = useLocation()
  const [project]: any = useState(location.state)
  const [id, setId]: any = useState("");
  const [max, setMax]: any = useState("");
  const [min, setMin]: any = useState("");
  const [tots, setTots] = useState("");
  const [Purpose, setPurpose]: any = useState("");
  const [modalopen, setModalopen] = useState(false);
  const [modalopen1, setModalopen1] = useState(false);
  const [Dname, setDname]: any = useState("");
  const [email, setEmail]: any = useState("");
  const [Cnumber, setCnumer]: any = useState("");
  const [Address, setAddress]: any = useState("");
  const [Camount, setCamount]: any = useState("");
  const [Remark, setRemark]: any = useState("");
  const [Identi, setIdenti] = useState(false);
  const [panNumber, setPanNumber]: any = useState("");
  const [bankName, setBankName]: any = useState("")
  const Razorpay = useRazorpay();
  const mailPat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const amtpat = /^[[0-9]{1,15}]*$/
  const namepat = /^[a-zA-Z\s]*$/
  const panPattern = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/
  const [Alert] = useIonAlert();
  const maxAmI = parseInt(max, 10);
  const minAmI = parseInt(min, 10);
  const [box, setBox]: any = useState(false);
  const history = useHistory();
  const [add, setAdd]: any = useState(sessionStorage.getItem("Address"));
  const [dmail, setDmail]: any = useState(sessionStorage.getItem("Email"))
  const [dphone, setDphone]: any = useState(sessionStorage.getItem("Phone"));
  const [name, setName]: any = useState(sessionStorage.getItem("Name"));
  const [che, setChe] = useState(false);
  const [enable, setEnable]: any = useState()
  const [signupmodal, setSignupmodal] = useState(false)
  const [loginmodal, setLoginmodal] = useState(false)
  const [iserror, setIserror] = useState(false);
  const [loginemail, setLoginEmail]: any = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [getAdd, setGetAdd] = useState(false);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false);


  const [contribute, setContribute] = useState(false);

  const formatter = new Intl.NumberFormat('en-IN')

  const [formErrors, setFormErrors]: any = useState({
  });
  const uFlag: any = useState(sessionStorage.getItem("uFlag"))
  useEffect(() => {
    if (userdata !== null && userdata !== "ROLE_USER") {
      history.push("/home")
    }
    else if (userdata !== null && uFlag[0] === "false") {
      history.push("/home")
    }
    else {
      if (sessionStorage.getItem("Address") && sessionStorage.getItem("Name")) {
        setEnable(false)
        setGetAdd(true)
      } else {
        setEnable(true)
        setGetAdd(false)
      }
      if (project !== undefined) {
        console.log(project, "yufv")
        setMin(project.item.minAmountDonate);
        setPurpose(project.item.purpose);
        setTots(project.item.totalSupporters);
        setId(project.item.id)
        setMax(project.item.maxAmountDonate)
      }
      else {
        history.push("/project")
      }
    }
  }, [])

  const check = (e: any) => {
    if (e.detail.checked) {
      setBox(true)
      setIdenti(true)
      setModalopen(!modalopen)
      setFormErrors((prev: any) => {
        return { ...prev, Dname: "", Cnumber: "", Address: "" }
      })
    }
    else {
      setBox(false)
      setIdenti(false)
    }

  }

  const contactnoref = useRef(null)

  const cursorend = (value: any) => {
    const input: any = contactnoref.current;
    if (window.innerWidth <= 500) {
      if (input) {
        setTimeout(() => {
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        }, 0);
      }
    }
    try {
      const phoneNumberObject: any = parsePhoneNumberFromString(value);
      setIsValidPhoneNumber(phoneNumberObject ? phoneNumberObject.isValid() : false);
      console.log(phoneNumberObject.isValid())
    } catch (error) {
      setIsValidPhoneNumber(false);
      console.log(error)
    }
    setCnumer(value)
  };

  const modalclose = () => {
    setIdenti(false)
    setModalopen(false)
  }

  const restrictE = (e: any) => {
    if (e.key == "e") {
      e.preventDefault()
    }
  }

  const preventdata = (e: any) => {
    e.target.addEventListener("wheel", function (s: any) { s.preventDefault() }, { passive: false })
    e.target.addEventListener('keydown', function (u: any) {
      if (u.which === 38 || u.which === 40) {
        u.preventDefault();
      }
    })
  }

  const Validation = (label: any) => {
    if (label === "pan") {
      if (panPattern.test(panNumber.toUpperCase()) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, pan: "Invalid PAN Number " }
        })
      } else {
        setFormErrors((prev: any) => {
          return { ...prev, pan: "" }
        })
      }
    }
    if (label === "nameAsBank") {
      if (bankName == "") {
        setFormErrors((prev: any) => {
          return { ...prev, nameAsBank: "Please enter name as per bank" }
        })
      } else {
        setFormErrors((prev: any) => {
          return { ...prev, nameAsBank: "" }
        })
      }
    }
    if (label === "Camount") {
      if (Camount == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "Please Enter Contribution Amount " }
        })
      }
      else if (Camount == "0") {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "Cannot Accept 0 as an Amount " }
        })
      }
      else if (amtpat.test(Camount) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "Invalid Contribution Amount " }
        })
      }
      else if (Camount < minAmI) {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: 'Minimum Contribution Amount: ₹ ' + formatter.format(min) }
        })
      }
      else if (Camount > maxAmI) {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: 'Maximum Contribution Amount: ₹ ' + formatter.format(max) }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "" }
        })
      }
    }


    if (label === "Identify") {
      if (Identi === true && Dname == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Reveal identity Details" }
        })
      }
      else if (Identi === true && namepat.test(Dname) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Alphabets only Allowed in Name on Contribute" }
        })
      }
      else if (Identi === true && email == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Email ID in Contribute" }
        })
      }
      else if (Identi === true && !isValidPhoneNumber) {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Valid Contact Number in Contribute" }
        })
      }
      else if (Identi === true && Address == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Address in Contribute" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "" }
        })
      }
    }

    if (label === "Dname") {
      if (Dname == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Dname: "Please Enter Name" }
        })
      }
      else if (namepat.test(Dname) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, Dname: "Alphabets only Allowed in Name" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Dname: "" }
        })
      }
    }

    if (label === "email") {
      if (email == "") {
        setFormErrors((prev: any) => {
          return { ...prev, email: "Please Enter Email ID" }
        })
      }
      else if (validator.isEmail(email) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, email: "Please Enter Valid Email Address" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, email: "" }
        })
      }
    }

    if (label === "contact") {
      if (Cnumber == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Cnumber: "Please Enter Contact Number" }
        })
      }
      else if (!isValidPhoneNumber) {
        setFormErrors((prev: any) => {
          return { ...prev, Cnumber: "Please Enter Valid Contact Number" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Cnumber: "" }
        })
      }
    }
    // else if (!(Cnumber.match('[0-9]{10}'))) {
    //   errors.Cnumber = 'Enter Valid Mobile Number'
    // }
    if (label === "Address") {
      if (Address == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Address: "Please Enter Address" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Address: "" }
        })
      }
    }
  }

  const ChangeValidation = (label: any, e: any) => {
    if (label === "pan") {
      if (panPattern.test(panNumber.toUpperCase()) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, pan: "Invalid PAN Number " }
        })
      } else {
        setFormErrors((prev: any) => {
          return { ...prev, pan: "" }
        })
      }
    }
    if (label === "nameAsBank") {
      if (bankName == "") {
        setFormErrors((prev: any) => {
          return { ...prev, nameAsBank: "Please enter name as per bank" }
        })
      } else {
        setFormErrors((prev: any) => {
          return { ...prev, nameAsBank: "" }
        })
      }
    }
    if (label === "email") {
      if (email == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Email ID in Contribute" }
        })
      }
      else if (validator.isEmail(email) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Valid Email Address in Contribute" }
        })
      }
    }
    if (label === "Camount") {
      const Camount = e.target.value;
      if (Camount == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "Please Enter Contribution Amount " }
        })
      }
      else if (Camount == "0") {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "Cannot Accept 0 as an Amount " }
        })
      }
      else if (amtpat.test(Camount) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "Invalid Contribution Amount " }
        })
      }
      else if (Camount < minAmI) {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: 'Minimum Contribution Amount: ₹ ' + formatter.format(min) }
        })
      }
      else if (Camount > maxAmI) {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: 'Maximum Contribution Amount: ₹ ' + formatter.format(max) }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Camount: "" }
        })
      }
    }


    if (label === "Identify") {
      const Dname = e.target.value;
      if (Identi === true && Dname == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Reveal identity Details" }
        })
      }
      else if (Identi === true && namepat.test(Dname) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Alphabets only Allowed in Name on Contribute" }
        })
      }
      else if (Identi === true && Cnumber == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Contact Number in Contribute" }
        })
      }
      else if (Identi === true && !isValidPhoneNumber) {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Valid Contact Number in Contribute" }
        })
      }
      else if (Identi === true && Address == "") {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "Please Enter Address in Contribute" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, revael: "" }
        })
      }
    }

    if (label === "Dname") {
      const Dname = e.target.value;

      if (Dname == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Dname: "Please Enter Name" }
        })
      }
      else if (namepat.test(Dname) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, Dname: "Alphabets only Allowed in Name" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Dname: "" }
        })
      }
    }

    if (label === "email") {
      const email = e.target.value;
      if (email == "") {
        setFormErrors((prev: any) => {
          return { ...prev, email: "Please Enter Email ID" }
        })
      }
      else if (validator.isEmail(email) == false) {
        setFormErrors((prev: any) => {
          return { ...prev, email: "Please Enter Valid Email Address" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, email: "" }
        })
      }
    }

    if (label === "contact") {
      const Cnumber = e;

      let valid: any = false
      try {
        const phoneNumberObject: any = parsePhoneNumberFromString(e);
        valid = phoneNumberObject ? phoneNumberObject.isValid() : false;
      } catch (error) {
        valid = false;
        console.log(error)
      }

      if (Cnumber == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Cnumber: "Please Enter Contact Number" }
        })
      }
      else if (!valid) {
        setFormErrors((prev: any) => {
          return { ...prev, Cnumber: "Please Enter Valid Contact Number" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Cnumber: "" }
        })
      }
    }
    // else if (!(Cnumber.match('[0-9]{10}'))) {
    //   errors.Cnumber = 'Enter Valid Mobile Number'
    // }
    if (label === "Address") {
      const Address = e.target.value;

      if (Address == "") {
        setFormErrors((prev: any) => {
          return { ...prev, Address: "Please Enter Address" }
        })
      }
      else {
        setFormErrors((prev: any) => {
          return { ...prev, Address: "" }
        })
      }
    }
  }

  const payment = () => {

    const errors: any = {};
    if (panPattern.test(panNumber.toUpperCase()) == false) {
      errors.pan = "Enter valid PAN number";
    }
    if (bankName == "") {
      errors.nameAsBank = "Please enter name as per bank";
    }
    if (Camount == "") {
      errors.Camount = "Please Enter Contribution Amount ";
    }
    else if (Camount == "0") {
      errors.Camount = "Cannot Accept 0 as an Amount ";
    }
    else if (amtpat.test(Camount) == false) {
      errors.Camount = "Invalid Contribution Amount ";
    }
    else if (Camount < minAmI) {
      errors.Camount = 'Minimum Contribution Amount: ₹ ' + formatter.format(min);
    }
    else if (Camount > maxAmI) {
      errors.Camount = 'Maximum Contribution Amount: ₹ ' + formatter.format(max);
    }
    if (email == "") {
      errors.email = ' Please Enter Email ID in Contribute'
    }
    else if (validator.isEmail(email) == false) {
      errors.email = 'Please Enter Valid Email Address in Contribute'
    }
    if (Identi === true && Dname == "") {
      errors.revael = 'Please Enter Reveal identity Details'
      console.log(errors.reveal, "kmk")
    }
    else if (Identi === true && namepat.test(Dname) == false) {
      errors.revael = 'Alphabets only Allowed in Name on Contribute'
    }
    else if (Identi === true && Cnumber == "") {
      errors.revael = 'Please Enter Contact Number in Contribute'
    }
    else if (Identi === true && !isValidPhoneNumber) {
      errors.revael = 'Please Enter Valid Contact Number in Contribute'
    }
    // else if (Identi === true && !(Cnumber.match('[0-9]{10}'))) {
    //   alert('Enter Valid Mobile Number in Contribute')
    // }
    else if (Identi === true && Address == "") {
      errors.revael = 'Please Enter Address in Contribute'
    }
    // else if (Identi === true && token == null) {
    //   setLoginmodal(true)
    // }
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      bookpayment(token, userId);

    }

  }
  const [errormodal, setErrormodal] = useState(false)
  const [errormsg, setErrormsg] = useState([])

  const bookpayment = (e: any, usrId: any) => {
    setShowLoading(true);
    var dataPay = {};
    if (Identi) {
      dataPay = {

        "donorName": Dname,
        "contactNumber": Cnumber,
        "address": Address,
        "contributionAmount": Camount,
        "panCardNumber": panNumber,
        "emailId": email,
        "nameAsPerBank": bankName,
        "projectModel": { id },
        "remarks": Remark,
        "userModel": {
          "id": usrId
        }
      }
    } else {
      dataPay = {
        "contributionAmount": Camount,
        "panCardNumber": panNumber,
        "nameAsPerBank": bankName,
        "projectModel": { id },
        "remarks": Remark,
        "emailId": email,
        "userModel": {
          "id": usrId
        }
      }
    }

    Authservice.ProjectDonationPayment(dataPay)
      .then((response) => {
        console.log("payresponse", response.data);
        var res = response.data;
        if (response.data.errors === null) {
          // if(res=='Donation Saved'){
          //   alert('your donation placed successfully')
          //   window.location.reload();
          // }
          var options: any = {
            key: response.data.pgOption.key,
            key_secret: response.data.secretKey,
            amount: response.data.pgOption.amount,
            currency: response.data.pgOption.currency,
            name: response.data.pgOption.name,
            order_id: response.data.pgOption.order_id,
            description: response.data.pgOption.description,
            modal: {
              escape: false, ondismiss: function () {
                // code here 
                Alert({
                  header: "Atmagram",
                  message: "Payment Failed",
                  backdropDismiss: false,
                  buttons: [
                    {
                      text: "ok",
                    }
                  ]
                })
              }
            },
            handler: function (res: any) {
              // alert(res.razorpay_payment_id+"/"+res.razorpay_order_id+res.razorpay_signature);
              var resData: any = {

                "amount": response.data.pgOption.amount,
                "orderId": res.razorpay_order_id,
                "cartPayRefId": response.data.cartPayRefId,
                "signature": res.razorpay_signature,
                "paymentId": res.razorpay_payment_id

              }
              console.log("resData", resData);
              Authservice.ProjectDonationPaymentMultiRes(resData)
                .then((response) => {
                  console.log("payresponse" + response);
                  Alert({
                    header: "Atmagram",
                    message: "Thanks for your contribution",
                    backdropDismiss: false,
                    buttons: [
                      {
                        text: "ok",
                        handler: () => {
                          window.location.reload()
                        }
                      }
                    ]
                  })
                })
                .catch((error) => {
                  Alert({
                    header: "Atmagram",
                    message: "Something went wrong, please try again later.",
                    backdropDismiss: false,
                    buttons: [
                      {
                        text: "ok",
                      }
                    ]
                  })
                });

            },
            prefill: {
              name: response.data.pgOption.name,
              email: response.data.email,
              contact: response.data.contact

            },

            theme: {
              color: response.data.theme
            }
          };
          var pay: any = new Razorpay(options)
          pay.on("payment.failed", function (data: any) {
            Alert({
              header: "Atmagram",
              backdropDismiss: false,
              message: data.error.reason,
              buttons: [
                {
                  text: "ok",
                }
              ]
            })
          });
          setShowLoading(false);
          pay.open()
          console.log(dataPay);
        }
        else {
          setErrormodal(true)
          console.log(response.data.errors)
          setErrormsg(response.data.errors)
        }
      })
      .catch((error) => {
        setShowLoading(false);
        Alert({
          header: "Atmagram",
          backdropDismiss: false,
          message: "Something went wrong, please try again later.",
          buttons: [
            {
              text: "ok",
            }
          ]
        })
      });
  }

  const show = () => {
    const errors: any = {};
    if (Dname == "") {
      errors.Dname = "Please Enter Name"
    }
    else if (namepat.test(Dname) == false) {
      errors.Dname = 'Alphabets only Allowed in Name'
    }

    if (Cnumber == "") {
      errors.Cnumber = 'Please Enter Contact Number'
    }
    else if (!isValidPhoneNumber) {
      errors.Cnumber = 'Please Enter Valid Contact Number'
    }
    // else if (!(Cnumber.match('[0-9]{10}'))) {
    //   errors.Cnumber = 'Enter Valid Mobile Number'
    // }
    if (Address == "") {
      errors.Address = 'Please Enter Address'
    }
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      setModalopen(false)
      setBox(false)
    }
  }
  const back = () => {
    history.push("/project")
  }
  const sameas = (e: any) => {
    const errors: any = {};
    if (e.target.checked) {
      setChe(true)
      if (name != null && name != "") {
        setDname(name)
      } else {
        errors.Dname = "Enter Name at My Profile"
      }

      if (dphone != null && dphone != "") {
        if (!dphone.startsWith("+")) {
          try {
            const phoneNumberObject: any = parsePhoneNumberFromString("+91" + dphone);
            setIsValidPhoneNumber(phoneNumberObject ? phoneNumberObject.isValid() : false);
            console.log(phoneNumberObject.isValid())
          } catch (error) {
            setIsValidPhoneNumber(false);
            console.log(error)
          }
          setCnumer("+91" + dphone)
        } else {
          try {
            const phoneNumberObject: any = parsePhoneNumberFromString(dphone);
            setIsValidPhoneNumber(phoneNumberObject ? phoneNumberObject.isValid() : false);
            console.log(phoneNumberObject.isValid())
          } catch (error) {
            setIsValidPhoneNumber(false);
            console.log(error)
          }
          setCnumer(dphone)
        }
      } else {
        errors.Cnumber = "Enter mobile number at My Profile"
      }
      if (add != null && add != "") {
        setAddress(add)
      } else {
        console.log("kk")
        errors.Address = "Enter Address Details at My Profile"
      }
    } else {
      setChe(false)

      setCnumer("")
      setDname("")
      setAddress("")
    }
    setFormErrors(errors);
    // if (Object.keys(errors).length !== 0) {
    //   setChe(false)
    //   setEmail("")
    //   setCnumer("")
    //   setDname("")
    //   setAddress("")
    // }
  }

  const useOutsideAlerter = (refer: any, conref: any, logref: any, signref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (refer.current && !refer.current.contains(event.target)) {
          setModalopen1(false)
        }
        if (conref.current && !conref.current.contains(event.target)) {
          setModalopen(false)
        }
        if (logref.current && !logref.current.contains(event.target)) {
          setLoginmodal(false)
        }
        if (signref.current && !signref.current.contains(event.target)) {
          setSignupmodal(false)
          setLoginmodal(true)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    }, [refer, conref]);
  }
  const projectdonationmodal = useRef(null);
  const contributemodal = useRef(null);
  const loginmodalref = useRef(null);
  const signupmodalref = useRef(null)

  useOutsideAlerter(projectdonationmodal, contributemodal, loginmodalref, signupmodalref);
  const { handleSubmit } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
  });
  const namecheck = /^[a-zA-Z\s]*$/

  const [user, setUser]: any = useState("2");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [password1, setPassword1] = useState("");

  const [aadhar1, setAadhar1] = useState("");

  const [firstname1, setFirstname1] = useState("");

  const [phone1, setPhone1] = useState("");

  const [email1, setEmail1] = useState("");
  const [issuccess, setIssuccess] = useState(false);

  const submit = () => {
    if (user === "") {
      alert("Chosse the User")
    }
    else if (firstname1 == "") {
      alert("Enter First Name")
    }
    else if (firstname1 == "") {
      alert("Enter First Name")
    }
    else if (namecheck.test(firstname1) == false) {
      alert('Alphabets only Allowed in First Name')
    }
    else if (firstname1.charAt(0) == " ") {
      alert('Empty Space at First Name')
    }
    else if (phone1.length !== 10) {
      alert("Enter Valid Phone Nuumber")
    }
    else if (validator.isEmail(email1) === false) {
      alert("Enter Valid Email Address")
    }
    else if (password1 !== confirmpassword) {
      alert("Password and confirm password are not same ")
    }
    else {
      console.log(aadhar1,
        email1,
        phone1,
        password1,
        user,
        user,
        firstname1)
      UserService.Registermaterials(
        // aadhar1,
        // addr,
        // pincode1,
        // area1,
        // city1,
        // state1,
        // country1,
        email1,
        firstname1,
        // lastname1,
        phone1,
        password1,
        user,
        user
      )
        .then((response) => {
          console.log("res", response);
          setShowLoading(false);
          if (response.responseText.startsWith("SUCCESS")) {
            setIssuccess(true);
            // setAadhar1("");
            // setAddr("");
            // setArea1("");
            // setCity1("");
            setConfirmpassword("");
            // setCountry1("");
            setEmail1("");
            setFirstname1("");
            // setLastname1("");
            setPassword("");
            setPhone1("");
            setUser("");
            // setPincode1("");
            setSignupmodal(false)
            setLoginmodal(true)
            alert("Successfully Signed Up");
            console.log(response, "resss =>")
          }
          else {
            alert("Email Id Exits, Try Any Other Email Id");
            setIserror(true);
          }
        })
        .catch((error) => {
          console.log(error)
          setShowLoading(false);
          alert("Something went wrong");
          setIserror(true);
        });
    }
  }
  const Searchlog = (value: any) => {
    if (value == "Enter") {
      if (email.length === 0) {
        alert("Enter Email Address")
      }
      else if (validator.isEmail(email) === false) {
        alert("Enter Valid Email Address")
      }
      else if (password.length == 0) {
        alert("Enter your Password")
      }
      else {
        Loginsubmit()
      }
    }
  }

  const Loginsubmit = () => {
    setShowLoading(true);
    UserService.Login(loginemail, password, "")
      .then((response) => {
        setShowLoading(false);
        setLoginmodal(false)
        if (response.data.responseText.startsWith("SUCCESS")) {
          // if (Capacitor.getPlatform() === "web") {
          //   console.log(response, "ressss")
          if (response.data.userModel.role !== "ROLE_USER") {
            alert("This Account is not a user")
          }
          else
            if (response.data.userModel.uflag === "false") {
              console.log(response.data.userModel.uflag, "uflag")
              alert("Account Not Approved Yet")
            }
            else {
              sessionStorage.setItem("token", response.data.userToken);
              sessionStorage.setItem("UserId", response.data.userModel.id);
              sessionStorage.setItem("UserData", response.data.userModel.role);
              sessionStorage.setItem("uFlag", response.data.userModel.uflag);
              sessionStorage.setItem("Email", response.data.userModel.email);
              sessionStorage.setItem("Phone", response.data.userModel.mobileNumber);
              if (response.data.userModel.firstName !== null) {
                sessionStorage.setItem("Name", response.data.userModel.firstName);
              }
              if (response.data.userModel.address !== null) {
                sessionStorage.setItem("Address", response.data.userModel.address);
              }
              // setLoginmodal(false)
              settoken(response.data.userToken)
              setUserdata(response.data.userModel.role)
              setUserId(response.data.userModel.id)
              setName(response.data.userModel.firstName)
              setDmail(response.data.userModel.email)
              setDphone(response.data.userModel.mobileNumber)
              setAdd(response.data.userModel.address)
              console.log(response.data.userToken)
              alert("Login Successful");
              bookpayment(response.data.userToken, response.data.userModel.id);
            }
        }
        // }
        else {
          alert(response.data.responseText.split("ERROR:")[1]);
        }
      })
      .catch((error) => {
        setLoginmodal(false)
        console.log(error);
        setShowLoading(false);
      });
  };

  const targetRef: any = useRef(null);

  const contributeBtn = () => {
    setContribute(true);
    setTimeout(() => {
      if (targetRef.current) {
        targetRef.current.scrollIntoView({ behavior: "smooth" });
      }
    })
  }

  return (
    <IonPage>
      <IonContent>
        <HeadFoot User={"donations"} Role={'Role'} Name={"Home,Projects"} />
        <Modal show={signupmodal}>
          <Modal.Body ref={signupmodalref}>
            <div className="modal-header">
              <h5 className="modal-title">Sign Up</h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setSignupmodal(false)}>
                <span aria-hidden="true">x</span>
              </button>
            </div>
            <div>
              <form onSubmit={handleSubmit(submit)}>
                <div>
                  <IonRow className="row_sign">
                    <IonCol size="12" size-lg="6">
                      <IonItem className="rounded Signup_modal">
                        <IonLabel className="sign_label_user">User</IonLabel>
                      </IonItem>
                    </IonCol>
                    <IonCol size="12" size-lg="6">
                      <IonItem className="rounded Signup_modal">
                        <IonLabel position="floating" className="sign_label">
                          First Name <span style={{ color: "red" }}>*</span>
                        </IonLabel>
                        <IonInput
                          type="text"
                          required
                          value={firstname1}
                          onIonChange={(e) => setFirstname1(e.detail.value!)}
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                  </IonRow>



                  <IonRow className="row_sign">
                    <IonCol size="12" size-lg="6">
                      <IonItem className="rounded Signup_modal">
                        <IonLabel className="sign_label" position="floating">
                          Mobile Number <span style={{ color: "red" }}>*</span>
                        </IonLabel>
                        <IonInput
                          type="tel"
                          inputMode="tel"
                          pattern="[0-9]{10}"
                          value={phone1}
                          maxlength={10}
                          required
                          onIonChange={(e) => setPhone1(e.detail.value!)}
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    <IonCol size="12" size-lg="6">
                      <IonItem className="rounded Signup_modal ">
                        <IonLabel className="sign_label" position="floating">
                          Email <span style={{ color: "red" }}>*</span>
                        </IonLabel>
                        <IonInput
                          type="email"
                          value={email1}
                          required
                          onIonChange={(e) => setEmail1(e.detail.value!)}
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    {/* <IonCol size="12" size-lg="6">
                      <IonItem className="rounded Signup_modal ">
                        <IonLabel className="sign_label" position="floating">
                          Aadhar Number <span style={{ color: "red" }}>*</span>
                        </IonLabel>
                        <IonInput
                          type="tel"
                          inputMode="tel"
                          pattern="[0-9]{12}"
                          required
                          maxlength={12}
                          value={aadhar1}
                          onIonChange={(e) => setAadhar1(e.detail.value!)}
                        ></IonInput>
                      </IonItem>
                    </IonCol> */}
                  </IonRow>
                  <IonRow className="row_sign">
                    <IonCol size="12" size-lg="6">
                      <IonItem className="rounded Signup_modal ">
                        <IonLabel className="sign_label" position="floating">
                          Password <span style={{ color: "red" }}>*</span>
                        </IonLabel>
                        <IonInput
                          type="password"
                          value={password1}
                          clearOnEdit={false}
                          required
                          onIonChange={(e) => setPassword1(e.detail.value!)}
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                    <IonCol size="12" size-lg="6">
                      <IonItem className=" rounded Signup_modal " >
                        <IonLabel className="sign_label" position="floating">
                          Confirm Password <span style={{ color: "red" }}>*</span>
                        </IonLabel>
                        <IonInput
                          type="password"
                          clearOnEdit={false}
                          value={confirmpassword}
                          required
                          onIonChange={(e) => setConfirmpassword(e.detail.value!)}
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol style={{ display: "flex", alignItems: "center", justifyContent: "center" }} size="12" size-lg="12" className="textalign-center">
                      <IonButton
                        className="submit"
                        type="submit"
                        onClick={() => submit}
                        disabled={
                          firstname1.length === 0 ||
                          phone1.length === 0 ||
                          //   area1.length === 0 ||
                          //   city1.length === 0 ||
                          //   state1.length === 0 ||
                          //   country1.length === 0 ||
                          email1.length === 0 ||
                          //   addr.length === 0 ||
                          password1.length === 0 ||
                          confirmpassword.length === 0
                          //   aadhar1.length === 0 ||
                          //   user == "" ||
                          //   pincode1.length != 6
                        }
                      >
                        Sign Up
                      </IonButton>
                    </IonCol>
                  </IonRow>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={loginmodal}>
          <Modal.Body ref={loginmodalref}>
            <div className="modal-header">
              <h5 className="modal-title">Atmagram</h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setLoginmodal(false)}>
                <span aria-hidden="true">x</span>
              </button>
            </div>
            <div style={{ textAlign: "center" }}>
              <form className="top" onSubmit={handleSubmit(Loginsubmit)} onKeyPress={e => Searchlog(e.key)}>
                <div>
                  <h4>Log In</h4>
                  <div>
                    <IonRow className="row_log ">
                      <IonCol>
                        <IonItem className="Login_modal  rounded">
                          <IonLabel position="floating" className="label_align">
                            Email
                          </IonLabel>
                          <IonInput
                            type="email"
                            value={loginemail}
                            onIonChange={(e) => setLoginEmail(e.detail.value!)}
                            required
                          ></IonInput>
                          {/* <span slot="error">Name is required</span> */}
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    <IonRow className="row_log ">
                      <IonCol>
                        <IonItem className="Login_modal rounded">
                          <IonLabel position="floating" className="label_align">
                            Password
                          </IonLabel>
                          <IonInput
                            type="password"
                            clearOnEdit={false}
                            onIonChange={(e) => setPassword(e.detail.value!)}
                            required
                          ></IonInput>
                        </IonItem>
                      </IonCol>
                    </IonRow>

                    <IonRow>
                      <IonCol size="12" size-lg="12" className="textalign-center">
                        <IonButton
                          className="submit"
                          type="submit"
                          disabled={email.length === 0 || password.length === 0}
                        >
                          Login
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  </div>
                </div>
              </form>
              <IonRow style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <IonCol size="3" size-lg="3">
                  <IonText>
                    Don't have an account ?
                  </IonText>
                </IonCol>
                <IonCol size="3" size-lg="3">
                  <IonButton
                    onClick={() => setSignupmodal(true)}
                  >
                    Sign Up
                  </IonButton>
                </IonCol>
              </IonRow>
            </div>
          </Modal.Body>
        </Modal>
        <div className="donation-container page_content_padding">
          <IonGrid>
            <IonRow>
              <IonCol size-lg="6" sizeMd="6" size="12" className="columns-donation">
                <IonRow>
                  <IonCol size="2" style={{ paddingTop: '10px' }}>
                    <IonIcon src={arrowBack} className="back" onClick={() => back()} size="large"></IonIcon>

                  </IonCol>
                  <IonCol size="10">
                    <h5 className="page-title">Donations</h5>
                  </IonCol>
                </IonRow>



                <p className="donation-content">
                  Sri Sankara Peetam, the promoter of Atmagram, is engaged in social welfare services for the benefit of the poor and needy. A vast area of services such as education, housing, economic empowerment, cultural upliftment, women and youth empowerment, legal support for the benefit of the underprivileged.
                </p>
                <div>
                  <IonButton onClick={() => contributeBtn()}> <span className="button_padding">Contribute</span></IonButton>
                </div>
              </IonCol>
              <IonCol size-lg="6" sizeMd="6" size="0" className="columns-donation">
                <IonImg src={joinhand} className="joinhand-img" />
                <div className="donation-supporters">
                  <div>
                    <IonImg src={heart1} className="donation-heart-icons" />
                  </div>
                  <div className="supporters-card-txtParent">
                    <p className="supporters-card-txt1">{tots}</p>
                    <p className="supporters-card-txt2">Happy Supporters</p>
                  </div>
                </div>
              </IonCol>
            </IonRow>
            {contribute === true ?
              <div ref={targetRef} className="contribute-donation">
                <h5 className="donation-title">Contribution</h5>
                <IonGrid>
                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm ">
                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonLabel className="contribute-labels">PAN Number <span style={{ color: "red" }}>*</span></IonLabel >
                    </IonCol>
                    <IonCol sizeLg="8" sizeMd="8" sizeSm="6" sizeXs="6">
                      <IonInput className="amt-textBox" value={panNumber} min={0} onFocus={preventdata}
                        onBlur={() => Validation("pan")} type='text'
                        onIonChange={(e: any) => {
                          setPanNumber((e.detail.value).toUpperCase());
                          //ChangeValidation("pan", e)
                        }} />
                      {formErrors.pan && <span className="alert_input_bottom ">{formErrors.pan}</span>}
                    </IonCol>
                  </IonRow>
                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm ">
                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonText className="contribute-labels" >Email-id <span style={{ color: "red" }}>*</span></IonText>
                    </IonCol>
                    <IonCol sizeLg="8" sizeMd="8" sizeSm="6" sizeXs="6">
                      <IonInput className="amt-textBox" onBlur={() => Validation("email")} value={email} onIonChange={(e: any) => { setEmail(e.detail.value); ChangeValidation("email", e) }} />
                      {formErrors.email && <span className="alert_input_bottom">{formErrors.email}</span>}
                    </IonCol>
                  </IonRow>
                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm ">
                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonLabel className="contribute-labels">Name as per bank<span style={{ color: "red" }}>*</span></IonLabel >
                    </IonCol>
                    <IonCol sizeLg="8" sizeMd="8" sizeSm="6" sizeXs="6">
                      <IonInput className="amt-textBox" value={bankName} min={0} onFocus={preventdata}
                        onBlur={() => Validation("nameAsBank")}
                        type='text' onIonChange={(e: any) => { setBankName(e.detail.value); ChangeValidation("nameAsBank", e) }} />
                      {formErrors.nameAsBank && <span className="alert_input_bottom ">{formErrors.nameAsBank}</span>}
                    </IonCol>
                  </IonRow>

                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm ">

                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonLabel className="contribute-labels">Contribution Amount <span style={{ color: "red" }}>*</span></IonLabel >

                    </IonCol>
                    <IonCol sizeLg="8" sizeMd="8" sizeSm="6" sizeXs="6">
                      <div className="project-contribute-inputElement">
                        <IonInput className="amt-textBox" min={0} onKeyDown={(e: any) => restrictE(e)} onFocus={preventdata} onBlur={() => Validation("Camount")} type='number' onIonChange={(e: any) => { setCamount(e.detail.value); ChangeValidation("Camount", e) }} />
                        <IonIcon src={informationCircleSharp} tabIndex={0}
                          onKeyDown={(e: any) => {
                            if (e.key === "Enter" || e.key === " ") {
                              setModalopen1(true)
                            }
                          }}
                          onClick={() => setModalopen1(true)} className='info_icon contribute-info-icon' />
                      </div>
                      {formErrors.Camount && <span className="alert_input_bottom ">{formErrors.Camount}</span>}
                    </IonCol>
                  </IonRow>
                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm ">

                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonLabel className="contribute-labels">Purpose</IonLabel >

                    </IonCol>
                    <IonCol sizeLg="8" sizeMd="8" sizeSm="6" sizeXs="6">
                      <IonTextarea className="contribution-remark contribution-purpose" value={Purpose} autoGrow onIonChange={(e: any) => setPurpose(e.detail.value)} readonly={true} />
                      {formErrors.Purpose && <span className="alert_input_bottom ">{formErrors.Purpose}</span>}
                    </IonCol>
                  </IonRow>
                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm " >

                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonLabel className="contribute-labels">Remark</IonLabel >

                    </IonCol>
                    <IonCol sizeLg="8" sizeMd="8" sizeSm="6" sizeXs="6">
                      <IonTextarea className="contribution-remark" value={Remark} onIonChange={(e: any) => setRemark(e.detail.value)} />
                    </IonCol>
                  </IonRow>
                  <IonRow className="donation-contribute-row">
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="donation-labels-colm ">
                      <IonIcon src={checkmarkCircleSharp} className="tick" />
                      <IonLabel className="contribute-labels">Reveal Identity</IonLabel >
                    </IonCol>
                    <IonCol sizeLg="4" sizeMd="4" sizeSm="6" sizeXs="6" className="revealColumn">
                      <IonCheckbox checked={Identi === true} tabIndex={0} onBlur={() => Validation("Identify")} onIonChange={(e: any) => { check(e); ChangeValidation("Identify", e) }} />
                    </IonCol>
                  </IonRow>
                  <div className="donation_payment">
                    <IonButton onClick={() => payment()}> <span className="button_padding">Proceed to Payment</span></IonButton>
                  </div>
                </IonGrid>
              </div>
              : <></>}
          </IonGrid>
          <Modal show={modalopen} className="donation-modal" centered>
            <Modal.Body>
              <div className="donation-modal-header">
                <h5 className="donation-modal-title">User Details</h5>
                <div>
                  <IonIcon src={close} className="close_icon" onClick={() => modalclose()} />
                </div>
              </div>
              <div className="donation-modal-content">
                <IonRow className="donation-modal-row">
                  <IonCol sizeLg="6" sizeMd="5" sizeSm="5" sizeXs="5" className="donation-labels-colm ">

                    <IonIcon src={checkmarkCircleSharp} className="tick" />
                    <IonText className="contribute-labels" >Donor Name <span style={{ color: "red" }}>*</span></IonText>

                  </IonCol>
                  <IonCol sizeLg="6" sizeMd="7" sizeSm="7" sizeXs="7">
                    <IonInput className="donation-modal-inputs" onBlur={() => Validation("Dname")} value={Dname} onIonChange={(e: any) => { setDname(e.detail.value); ChangeValidation("Dname", e) }} />
                    {formErrors.Dname && <span className="alert_input_bottom">{formErrors.Dname}</span>}
                  </IonCol>
                </IonRow>
                <IonRow className="donation-modal-row">
                  <IonCol sizeLg="6" sizeMd="5" sizeSm="5" sizeXs="5" className="donation-labels-colm ">

                    <IonIcon src={checkmarkCircleSharp} className="tick" />
                    <IonText className="contribute-labels" >Contact Number <span style={{ color: "red" }}>*</span></IonText>

                  </IonCol>
                  <IonCol sizeLg="6" sizeMd="7" sizeSm="7" sizeXs="7">
                    <PhoneInput
                      international
                      className="donation-modal-inputs"
                      defaultCountry="IN"
                      value={Cnumber}
                      // flags=false
                      onBlur={() => Validation("contact")}
                      ref={contactnoref}
                      onChange={(value: any) => { cursorend(value); ChangeValidation("contact", value) }} />
                    {formErrors.Cnumber && <span className="alert_input_bottom">{formErrors.Cnumber}</span>}
                    {/* <IonInput className="TextInputStyle3" type="tel" maxlength={10} value={Cnumber} onIonChange={(e: any) => setCnumer(e.detail.value)} /> */}
                  </IonCol>
                </IonRow>
                <IonRow className="donation-modal-row">
                  <IonCol sizeLg="6" sizeMd="5" sizeSm="5" sizeXs="5" className="donation-labels-colm ">

                    <IonIcon src={checkmarkCircleSharp} className="tick" />
                    <IonText className="contribute-labels" >Address <span style={{ color: "red" }}>*</span></IonText>

                  </IonCol>
                  <IonCol sizeLg="6" sizeMd="7" sizeSm="7" sizeXs="7">
                    <IonTextarea className="donation-modal-inputs address-donation" autoGrow onBlur={() => Validation("Address")} value={Address} onIonChange={(e: any) => { setAddress(e.detail.value); ChangeValidation("Address", e) }} />
                    {formErrors.Address && <span className="alert_input_bottom">{formErrors.Address}</span>}
                    {userdata ?
                      <IonRow>
                        <IonCol className="donation-sameas">
                          <IonCheckbox onIonChange={(e: any) => sameas(e)} tabIndex={0} checked={che} />
                          <IonLabel>Same As Profile</IonLabel>
                        </IonCol>
                      </IonRow> : <></>}
                  </IonCol>
                </IonRow>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <IonButton onClick={() => show()}><span className="button_padding">Save</span></IonButton>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Modal show={errormodal} className="gramerce-modal" centered>
            <Modal.Body>
              <div className="modal-header">
                <h5 className="modal-title">Atmagram</h5>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setErrormodal(false)}>
                  <span aria-hidden="true">x</span>
                </button>
              </div>
              {errormsg.map((item: any, i: any) => (
                <div style={{ display: "flex", marginTop: "10px" }}>
                  <IonText style={{ fontWeight: "bold" }}>{i + 1}.</IonText>
                  <IonText style={{ paddingLeft: "5px" }}>{item}</IonText>
                </div>
              ))}
            </Modal.Body>
          </Modal>
          <Modal show={modalopen1} className="donation-modal" centered>
            <Modal.Body ref={projectdonationmodal} className="custom-modal">
              <div className="donation-modal-header project-modal-header">
                <h5 className="donation-modal-title">Atmagram</h5>
                <div>
                  <IonIcon src={close} className="close_icon" onClick={() => setModalopen1(false)} />
                </div>
              </div>
              <div className='donation-modal-content'>
                <IonRow style={{ justifyContent: "center" }}>
                  <IonLabel>The Minimum Contribution Amount for the Project : </IonLabel>
                  <IonText style={{ paddingLeft: "1%", fontWeight: "bold" }}>₹ {formatter.format(min)}</IonText>
                </IonRow>
                <IonRow style={{ justifyContent: "center" }}>
                  <IonLabel>The Maximum Contribution Amount for the Project : </IonLabel>
                  <IonText style={{ paddingLeft: "1%", fontWeight: "bold" }}>₹ {formatter.format(max)}</IonText>
                </IonRow>
              </div>
            </Modal.Body>
          </Modal>
        </div>

        <Foot />
      </IonContent>
    </IonPage>
  );
};

export default ProjectDonationUser;